import(/* webpackMode: "eager" */ "/app/frontend/apps/org/src/app/[locale]/error.tsx");
